import { FC, useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import * as paths from 'src/constants/paths';
import { useMixpanel, mixpanelEvents } from '../hooks/useMixpanel';
import { getCurrentRole } from 'src/store/app/reducer';
import { Roles } from '../interfaces/user';

const pageNames: Record<string, any> = {
  [paths.SIGN_IN_PAGE]: { page: 'Sign In' },
  [paths.SIGN_UP_PAGE]: { page: 'Sign Up' },
  [paths.REGISTRATION_PAGE]: { page: 'Registration' },
  [paths.HOME_PAGE]: { page: 'Home' },
  [paths.PROFILE_COMPLETION_PAGE]: { page: 'Complete Registration' },
  [paths.MENU_NOTIFICATION_PAGE]: { page: 'Menu Notifications' },
  [paths.PORTFOLIO_PAGE]: { page: 'Portfolio' },
  [paths.PORTFOLIO_DETAIL_PAGE]: { page: 'Portfolio Details' },
  [paths.PORTFOLIO_INVESTMENT_OFFERING_PAGE]: { page: 'Portfolio Investment Offering' },
  [paths.PORTFOLIO_VENTURES_UPDATES_PAGE]: { page: 'Portfolio Updates' },
  [paths.PORTFOLIO_UPDATES_PAGE]: { page: 'Portfolio Updates' },
  [paths.PORTFOLIO_SHARE_ALLOCATION]: { page: 'Portfolio Share Allocation' },
  [paths.SUCCESS_IDENTIFICATION_PAGE]: { page: 'Success Identification' },
  [paths.FAIL_IDENTIFICATION_PAGE]: { page: 'Fail Identification' },
  [paths.ISSUER_SETUP_PAGE]: { page: 'Create Issuer' },
  [paths.OFFERINGS_PAGE]: { page: 'Investment Offerings Page' },
  [paths.DEAL_ROOM_PAGE]: { page: 'Deal Room' },
  [paths.PAYMENT_CONFIRMATION_PAGE]: { page: 'Investment Commitment Payment' },
  [paths.ASSET_INVESTMENT_CLOSING_PAGE]: { page: 'Asset Investment Closing' },
  [paths.REGULATORY_APPROVAL_PAGE]: { page: 'Regulatory Approval' },
  [paths.SIGN_INVESTMENT_PAGE]: { page: 'Sign Your Investment' },
  [paths.SPV_ISSUANCE_AGREEMENT_SIGNING]: { page: 'SPV Issuance Agreement Signing' },
  [paths.MENU_PAGE]: { page: 'Menu Page' },
  [paths.MENU_WALLET_SETUP_PAGE]: { page: 'Menu Wallet Setup' },
  [paths.INVESTOR_CRM_PAGE]: { page: 'Investor CRM PAge' },
  [paths.OFFERINGS_ARCHIVE_PAGE]: { page: 'Investment Offerings Archive Page' },
  [paths.OFFERINGS_COMPLETED_PAGE]: { page: 'Investment Offerings Completed Page' },
  ['/']: { page: 'Index Page' },
};

export const MixpanelProvider: FC = (props) => {
  const router = useRouter();
  const { track } = useMixpanel();
  const initialLoad = useRef(true);
  const role = useSelector(getCurrentRole);

  useEffect(() => {
    const handleRouteChange = () => {
      if (
        router.route === paths.HOME_PAGE &&
        !(role && [Roles.INVESTOR, Roles.VENTURE_FOUNDER].includes(role))
      ) {
        return;
      }

      const pageData = pageNames[router.route];

      if (pageData) {
        track(mixpanelEvents.userViewPage, pageData);
      }
    };

    if (initialLoad.current) {
      handleRouteChange();
      if (!(router.route === paths.HOME_PAGE && !role)) {
        initialLoad.current = false;
      }
    }

    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, role, track]);

  return <>{props.children}</>;
};
